import React, { useEffect, useState, useRef, useContext } from 'react'

import styles from './Conyuge.module.css'
//Utiles
import * as Constantes from '../../utils/constantes'
import * as Funciones from '../../utils/funciones'
import GeneralContext from '../../context/GeneralContext'
import CampoFecha from '../CampoFecha/CampoFecha'

const Conyuge = ({ conyuge, state, setState, familiar }) => {
  const { state: generalState } = useContext(GeneralContext)
  let user = generalState.users.filter(user => user.isAuthenticated)[0]
  let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]
  let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

  const [documentos, setDocumentos] = useState([])
  const [ocupaciones, setOcupaciones] = useState([])
  const [stateOcupacion, setStateOcupacion] = useState({})
  const ocupacionRef = useRef()
  
  useEffect(() => {
    setOcupaciones(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 9))
    setDocumentos(Funciones.obtenerTablasMaestras(generalState.tablasMaestras, 13))
  }, [])

  const onChangeInputDate = (valor) => {
    handleChangeFecha(valor, 'fechaNacimiento')
  }
  const handleChangeTexto = (event, campo) => {
    let valor = event.target.value.replace(/[^a-z A-Z À-ÿ \u00f1\u00d1]/gi, "")
    setState((state) => {
      return {
        ...state,
        conyuge: {
          ...state.conyuge,
          [campo]: valor
        },
        campoValidado: {
          ...state.campoValidado,
          [campo]: true
        }
      }
    })
  }

  const handleChangeSexo = (event) => {
    const sexoVal = event.target.value
    setState((state) => {
      return {
        ...state,
        conyuge: {
          ...state.conyuge,
          sexo: {
            codigo: parseInt(sexoVal)
          }
        },
        campoValidado: {
          ...state.campoValidado,
          sexo: true
        }
      }
    })
  }

  const handleChangeCombo = (event, campo) => {
    let codigo = event.target.value
    let descripcion = event.target[event.target.selectedIndex].text
    setState((state) => {
      return {
        ...state,
        conyuge: {
          ...state.conyuge,
          [campo]: {
            codigo: parseInt(codigo),
            descripcion: descripcion
          },
          numeroDocumento: ''
        },
        campoValidado: {
          ...state.campoValidado,
          tipoDocumentoConyuge: true
        }
      }
    })
  }

  const handleChangeFecha = (event, campo) => {
    let valor = event
    setState((state) => {
      return {
        ...state,
        conyuge: {
          ...state.conyuge,
          [campo]: Funciones.transformarDatePickerToFecha(valor)
        },
        campoValidado: {
          ...state.campoValidado,
          [campo]: true
        }
      }
    })
  }

  const handleChangeNumerico = (e, campo, codigo) => {
    let valor = ''
    switch (codigo) {
      case 1:
        valor = e.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, "")
        break;
      case 3:
        valor = e.target.value.replace(/[^0-9A-Z]/gi, "")
        valor = valor.toUpperCase()
        break;
      case 4:
        valor = e.target.value.replace(/[^0-9 \u00f1\u00d1]/gi, "")
        break;
      default:
        console.error('No existe un Tipo de documento válido')
    }
    setState((state) => {
      return {
        ...state,
        conyuge: {
          ...state.conyuge,
          [campo]: valor
        },
        campoValidado: {
          ...state.campoValidado,
          numeroDocumentoConyuge: true
        }
      }
    })
  }

  const handleChangeOcupacion = (event) => {
    if (event.target.value.length > 2) {
      let ocupacionesFilter = ocupaciones.filter(ocupacion => ocupacion.valor.toUpperCase().indexOf(event.target.value.toUpperCase()) >= 0)
      setStateOcupacion({
        ...stateOcupacion,
        descripcion: event.target.value,
        verOcupaciones: true,
        ocupacionesFilter: ocupacionesFilter
      })
    } else {
      setStateOcupacion({
        ...stateOcupacion,
        descripcion: '',
        verOcupaciones: false,
        ocupacionesFilter: []
      })
      setState((state) => {
        return {
          ...state,
          conyuge: {
            ...state.conyuge,
            ocupacion: null
          }
        }
      })
    }
  }

  const handleOcupacionClick = (ocupacion) => {
    setStateOcupacion({
      ...stateOcupacion,
      descripcion: ocupacion.valor,
      ocupacion: ocupacion,
      verOcupaciones: false,
      errorSeleccionandoOcupacion: false
    })
    setState((state) => {
      return {
        ...state,
        conyuge: {
          ...state.conyuge,
          ocupacion: {
            codigo: ocupacion.id,
            descripcion: ocupacion.valor
          }
        },
        campoValidado: {
          ...state.campoValidado,
          ocupacion: true
        }
      }
    })
    ocupacionRef.current.value = ocupacion.valor
  }

  //Modo lectura
  let Deshabilitar = (complete) => {
    complete = cotizacion.edicionInhabilitada
    if (complete === true) {
      return true
    } else {
      return false
    }
  }

  const tamanioDocumento = (codigo) => {
    if (codigo !== null && codigo !== undefined) {
      return Constantes['CANTIDAD_DIGITOS_TIPO_DOCUMENTO_' + codigo]
    } else {
        return '0'
    }
  }

  return (
    <React.Fragment>
      <p className={styles['areadatosprospecto__subtitulo2']}>Sobre tu cónyuge</p>
      <div className={styles['contenedor']}>
        <div className={styles["caja-1"]}>
          <label>Nombres&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
          <input type='text'
            className={!state.campoValidado.nombres ? styles['logerror'] : null}
            value={(conyuge && conyuge.nombres && Funciones.mostrarCamelCase(conyuge && conyuge.nombres)) || ''}
            onChange={(e) => handleChangeTexto(e, 'nombres')}
            disabled={Deshabilitar() !== true ? false : true}
            maxLength={40}
          />
          {!state.campoValidado.nombres &&
            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_NOMBRES}</span>
          }
        </div>
        <div className={styles["caja-2"]}>
          <label>Apellido Paterno&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
          <input type='text'
            className={!state.campoValidado.apellidoPaterno ? styles['logerror'] : null}
            value={(conyuge && conyuge.apellidoPaterno && Funciones.mostrarCamelCase(conyuge && conyuge.apellidoPaterno)) || ''}
            onChange={(e) => handleChangeTexto(e, 'apellidoPaterno')}
            disabled={Deshabilitar() !== true ? false : true} 
            maxLength={30}
          />
          {!state.campoValidado.apellidoPaterno &&
            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_APE_PATERNO}</span>
          }
        </div>
        <div className={styles["caja-3"]}>
          <label>Apellido Materno&nbsp;{((conyuge !== null && conyuge !== undefined) && 
          (conyuge && conyuge.tipoDocumento) && (conyuge && conyuge.tipoDocumento.codigo)) !== 3 ?
            Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS : null}</label>
          <input type='text'
            className={!state.campoValidado.apellidoMaterno ? styles['logerror'] : null}
            value={(conyuge && conyuge.apellidoMaterno && Funciones.mostrarCamelCase(conyuge && conyuge.apellidoMaterno)) || ''}
            onChange={(e) => handleChangeTexto(e, 'apellidoMaterno')}
            disabled={Deshabilitar() !== true ? false : true}
            maxLength={30}
          />
          {!state.campoValidado.apellidoMaterno &&
            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_APE_MATERNO}</span>
          }
        </div>
        <div className={styles["caja-4"]}>
          <label>Tipo Doc.&nbsp;{familiar ? Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS : null}</label>
          <select
            className={!state.campoValidado.tipoDocumentoConyuge ? `${styles['logerror']} ${styles['tipoDoc']}` : styles['tipoDoc']}
            value={conyuge && conyuge.tipoDocumento ?
              conyuge.tipoDocumento.codigo : ''}
            onChange={(e) => handleChangeCombo(e, 'tipoDocumento')}
            disabled={Deshabilitar() !== true ? false : true}>
            <option value={0}>Seleccione</option>
            {documentos && documentos.length > 0 && documentos.filter(doc => doc.id !== 2 && doc.id !== 5).map(documento => (
              <option key={documento.id} value={documento.id}>
                {documento.valor}
              </option>
            ))}
          </select>
          {!state.campoValidado.tipoDocumentoConyuge &&
            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_TIP_DOCUMENTO}</span>
          }
        </div>
        <div className={styles["caja-5"]}>
          <label>Nro. de Documento&nbsp;{familiar ? Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS : null}</label>
          <input type='text'
            className={!state.campoValidado.numeroDocumentoConyuge ? styles['logerror'] : null}
            value={(conyuge && conyuge.numeroDocumento) || ''}
            maxLength={tamanioDocumento(conyuge && conyuge.tipoDocumento && conyuge.tipoDocumento.codigo)}
            onChange={(e) => handleChangeNumerico(e, 'numeroDocumento', conyuge.tipoDocumento.codigo)}
            disabled={Deshabilitar() !== true ? false : true} />
          {!state.campoValidado.numeroDocumentoConyuge &&
            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_NUM_DOCUMENTO}</span>
          }
        </div>
      </div>
      <div className={styles['contenedor2']}>
        <div className={styles['box1']}>
          <label>Ocupación&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
          <input
            type='text'
            className={!state.campoValidado.ocupacion ? styles['logerror'] : null}
            defaultValue={conyuge && conyuge.ocupacion ? conyuge.ocupacion.descripcion : ''}
            onChange={handleChangeOcupacion}
            ref={ocupacionRef}
            disabled={Deshabilitar() !== true ? false : true} />
          <div id="myInputautocomplete-list" className={styles['autocomplete-items']}>
            {stateOcupacion.verOcupaciones
              ? stateOcupacion.ocupacionesFilter.map(ocupacion => (
                <div key={ocupacion.id} onClick={event => handleOcupacionClick(ocupacion)}>
                  {ocupacion.valor.substring(0, ocupacion.valor.toUpperCase().indexOf(stateOcupacion.descripcion.toUpperCase()))}
                  <strong>{Funciones.mostrarCamelCase(ocupacion.valor).substring(ocupacion.valor.toUpperCase().indexOf(stateOcupacion.descripcion.toUpperCase()), 
                    ocupacion.valor.toUpperCase().indexOf(stateOcupacion.descripcion.toUpperCase()) + stateOcupacion.descripcion.length)}
                  </strong>
                  {ocupacion.valor.substring(
                    ocupacion.valor.toUpperCase().indexOf(stateOcupacion.descripcion.toUpperCase()) + stateOcupacion.descripcion.length,
                    ocupacion.valor.length
                  )}
                </div>
              ))
              : null}
          </div>
          {!state.campoValidado.ocupacion &&
            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_OCUPACION}</span>
          }
        </div>
        {/*Se utiliza el componente CampoFecha */}
        <div className={styles['box2']}>
          <CampoFecha
            name={'Fecha Nacimiento'}
            esObligatorio={true}
            valor={((conyuge !== null && conyuge !== undefined) && conyuge.fechaNacimiento && conyuge.fechaNacimiento !== '1901-01-01')
              ? Funciones.transformarFechaToDatePicker(conyuge.fechaNacimiento) : ''}
            disabled={Deshabilitar() !== true ? false : true}
            onChange={(valor) => onChangeInputDate(valor)}
            validacion={state.campoValidado.fechaNacimiento}
            mensaje={Constantes.MENSAJE_VALIDACION_FEC_NACIMIENTO}
          />
        </div>
        <div className={styles['box3']}>
          <label>Sexo&nbsp;{Constantes.SIMBOLO_OBLIGATORIEDAD_INPUTS}</label>
          <div className={styles['centered']}>
            <label className={styles['label-radio']}>
              <input 
                type="radio"
                name="sexo"
                value={0}
                selected={(conyuge !== null && conyuge !== undefined) && conyuge.sexo !== undefined && conyuge.sexo !== null
                  ? conyuge.sexo.codigo === 0 : false}
                checked={(conyuge !== null && conyuge !== undefined) && conyuge.sexo !== undefined && conyuge.sexo !== null
                  ? conyuge.sexo.codigo === 0 : false}
                onChange={handleChangeSexo}
                disabled={Deshabilitar() !== true ? false : true} />
                <span className="span-radio-sexo">Femenino</span>
              </label>
            <label className={styles['label-radio']}>
              <input 
                type="radio"
                name="sexo"
                value={1}
                selected={(conyuge !== null && conyuge !== undefined) && conyuge.sexo !== undefined && conyuge.sexo !== null
                  ? conyuge.sexo.codigo === 1 : false}
                checked={(conyuge !== null && conyuge !== undefined) && conyuge.sexo !== undefined && conyuge.sexo !== null
                  ? conyuge.sexo.codigo === 1 : false}
                onChange={handleChangeSexo}
                disabled={Deshabilitar() !== true ? false : true} />
                  <span className="span-radio-sexo">Masculino</span>
              </label>
          </div>
          {!state.campoValidado.sexo &&
            <span className={styles['span-error']}>{Constantes.MENSAJE_VALIDACION_SEXO}</span>
          }
        </div>
      </div>
    </React.Fragment>
  )
}

export default Conyuge